// extracted by mini-css-extract-plugin
export default {"logoSaltex":"PPMain_logoSaltex__kYmQt"};